<template>
  <div>
    <!-- List -->
    <div>
      <vs-table
        id="month-list"
        class="vs-con-loading__container"
        stripe
        :sst="true"
        maxHeight="800px"
        @search="updateSearchQuery"
        @change-page="handleChangePage"
        @sort="handleSort"
        :total="FilteredCount"
        :max-items="length"
        search
        :data="records"
      >
        <template slot="header">
          <div class="mb-2 flex items-center">
            <div class="flex flex-wrap justify-between items-center">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                  <div class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (FilteredCount && 1)) || 0 }}
                      -
                      {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                      of {{ total || 0 }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
            <div
              v-if="checkPermissionSlug(['month_management_create'])"
              @click="addPage"
              class="btn-add-new p-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add {{ module_name }}</span>
            </div>
            <div class="flex flex-wrap items-center">
              <!-- Custom Pagination -->
              <vs-pagination v-if="FilteredCount" v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 5" class="mt-1"></vs-pagination>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th>Sr#</vs-th>
          <vs-th>{{ module_name }} Name</vs-th>
          <vs-th>Start Date</vs-th>
          <vs-th>End Date</vs-th>
          <vs-th v-if="checkPermissionSlug(['month_management_delete']) || checkPermissionSlug(['month_management_edit'])">Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <vs-td class="text-left">
              <span class="cursor-pointer" v-if="checkPermissionSlug(['month_management_edit'])" @click.stop="toggleEditModal(tr._id, $event)" v-tooltip="{ content: `Edit ${tr.month_name}` }">{{
                tr.month_name || '-'
              }}</span>
              <span v-else>{{ tr.month_name || '-' }}</span>
            </vs-td>
            <vs-td class="text-left">
              <p class="capitalize">{{ formatDate(tr.start_date) }}</p>
            </vs-td>
            <vs-td class="text-left">
              <p class="capitalize">{{ formatDate(tr.end_date) }}</p>
            </vs-td>
            <!-- <vs-td>
              <vs-switch icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" color="primary" :value="tr.is_active" @click.stop="updateStatus(tr._id, !tr.is_active)">
                <span slot="on"></span>
                <span slot="off"></span>
              </vs-switch>
            </vs-td> -->
            <vs-td v-if="checkPermissionSlug(['month_management_delete']) || checkPermissionSlug(['month_management_edit'])">
              <div class="inline-flex">
                <vx-tooltip v-if="checkPermissionSlug(['month_management_edit'])" :text="`Edit ${module_name}`">
                  <feather-icon @click.stop="toggleEditModal(tr._id, $event)" icon="EditIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
                <vx-tooltip v-if="checkPermissionSlug(['month_management_delete'])" :text="`Delete ${module_name}`">
                  <feather-icon @click.stop="deleteRecord(tr._id)" icon="Trash2Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { dateMixins } from '@/mixins/dateMixins.js'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'Month-List',

  /** Data */
  data: () => ({
    order: [],
    length: 100,
    page: 1,
    search: '',
    module_name: 'Month',
    route_slug: 'month'
  }),

  /** computed */
  computed: {
    ...mapState('month', ['records', 'total', 'FilteredCount', 'listLoading']),
    ...mapGetters('auth', ['checkPermissionSlug']),
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    }
  },

  // Date Formate.
  mixins: [dateMixins],

  /** Functions */
  methods: {
    ...mapActions('month', {
      get: 'get',
      delete: 'delete'
    }),

    /** Per Page Limit Change */
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    /** Page Change */
    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    /** Sorting Table Data */
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    /** Search Query */
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    /** Gurudwara List API */
    getData() {
      this.get({
        // order: this.order,
        limit: this.length,
        page: this.page,
        search: this.search
      })
    },

    // Add modal
    addPage() {
      this.$router.push(`/${this.route_slug}/add`)
    },

    // Edit modal
    toggleEditModal(id, event) {
      const editUrl = `/${this.route_slug}/${id}/edit`
      if (event.ctrlKey || event.metaKey) {
        // Let browser handle the default Ctrl + Click behavior
        window.open(editUrl, '_blank')
      } else {
        // Navigate in the same tab
        this.$router.push(editUrl)
      }
    },

    /** Delete Confirmation */
    deleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete this record?`,
        accept: () => this.deleteSingleRecord(id),
        acceptText: 'Delete'
      })
    },

    /** Delete API */
    async deleteSingleRecord(id) {
      try {
        const { message } = await this.delete(id)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          position: 'top-center',
          time: 5000,
          icon: 'icon-alert-circle',
          color: 'primary'
        })
      }
    }

    /** updateStatus API */
    // updateStatus(id, status) {
    //   this.$store
    //     .dispatch('service/updateStatus', {
    //       id,
    //       status
    //     })
    //     .then((Success) => {
    //       const { message } = Success
    //       this.$vs.notify({
    //         title: 'Success',
    //         text: message,
    //         iconPack: 'feather',
    //         icon: 'icon-alert-circle',
    //         position: 'top-center',
    //         time: 5000,
    //         color: 'success'
    //       })
    //     })
    //     .catch((err) => {
    //       const { message } = err
    //       this.$vs.notify({
    //         title: 'Error',
    //         text: message,
    //         iconPack: 'feather',
    //         icon: 'icon-alert-circle',
    //         position: 'top-center',
    //         time: 5000,
    //         color: 'primary'
    //       })
    //     })
    // }
  },

  /** Watchers */
  watch: {
    listLoading() {
      if (this.listLoading) {
        this.$vs.loading({
          container: '#month-list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#month-list > .con-vs-loading')
      }
    },
    page() {
      this.getData()
    }
  },

  /** On Rendering */
  mounted() {
    this.getData()
  }
}
</script>
